<div class="container" *ngIf="!isMobileAddClicked else showMobileGoBack">
  <div class="d-md-none back" style="display: flex">
    <div style="margin-right: 10px">
      <a style="cursor: pointer;" (click)="backClicked()">
        <img alt="Go Back" src="assets/images/general/arrowleft.webp">
        <img alt="Go Back" src="assets/images/fund/Vec.svg" class="mobile-icons dark-mode-icon" style="width: 20px;">
      </a>
    </div>
  </div>
  <h3 class="filter-title mb-md-3 mb-2" id="forRoute">
    {{ "products.Watchlist-heading" | translate }}
  </h3>
</div>
<ng-template #showMobileGoBack>
  <div class="container" style="margin-top: -15px;">
    <div class="d-md-none mb-3">
      <a (click)="mobileAddFundGoBack()">
        <img alt="image" src="assets/images/general/arrowleft.webp">
        <img alt="image" src="assets/images/fund/Vec.svg" class="mobile-icons dark-mode-icon" style="width: 20px;">
      </a>
    </div>
  </div>
</ng-template>
<div class="container" *ngIf="!isMobileAddClicked ">
  <div class="mb-4">
    {{ "products.aboutWatchlist" | translate }}
  </div>

  <div class="row">
    <div class="col-lg-auto d-none d-lg-block" *ngIf="isRecentSearchAddButton">
      <div class="sticky-filter">
        <div class="Ft-watchlist-content-filter-head">{{ "products.categories" | translate }}</div>
        <div class="nav flex-column nav-pills watchlist-tab-box" id="v-pills-tab" role="tablist"
             aria-orientation="vertical" style="min-width: 245px;">
          <ng-container *ngFor="let element of categoryOptions">
            <button class="nav-link ms-2" [id]="element.name" [ngClass]="element.id == 1 ? 'active' : ''"
                    data-bs-toggle="pill" data-bs-target="#v-pills-focus" type="button" role="tab"
                    aria-controls="v-pills-focus" aria-selected="true"
                    (click)="showContentOnHover($event)">{{ element.name }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-lg forwatchlistchangetab">
      <div class="FT-watchlist-content-sticky-tab">
        <div class="d-flex fund-type-tab justify-content-between align-items-sm-center tab-head mb-3">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="watch-list-tab" data-bs-toggle="tab"
                      data-bs-target="#watch-list" (click)="getCategoryList('watch-list-tab')" type="button" role="tab"
                      aria-controls="home-tab-pane"
                      aria-selected="true">{{ "products.all-funds-watchlist-btn" | translate }}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="recent-searches-tab" data-bs-toggle="tab"
                      data-bs-target="#recent-searches" (click)="getCategoryList('recent-searches-tab')" type="button"
                      role="tab"
                      aria-controls="profile-tab-pane"
                      aria-selected="false">{{ "products.watchlistRecentSearch" | translate }}
              </button>
            </li>
          </ul>
          <ng-container *ngIf="fullFundsArray?.length !==9 else watchListFull">
            <ng-container *ngIf="isMobileView else desktop">
              <button class="btn btn-primary d-md-block" [disabled]="isAddFundsDisabled"
                      (click)="addFundsButtonClick()">{{ "products.add-fund-button-label" | translate }}
              </button>
            </ng-container>
            <ng-template #desktop>
              <button class="btn btn-primary d-md-block" data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasExample" aria-controls="offcanvasExample"
                      [disabled]="isAddFundsDisabled"
                      (click)="addFundsButtonClick()">{{ "products.add-fund-button-label" | translate }}
              </button>
            </ng-template>

          </ng-container>
          <ng-template #watchListFull>
            <button class="btn btn-primary" (click)="closeWatchListFull()">Watchlist Full</button>
          </ng-template>
        </div>
      </div>

      <div class="d-md-none" *ngIf="isRecentSearchAddButton">
        <div class="tab-head mb-4 forwatclistnavtab side-filter-options">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation"
                *ngFor="let element of categoryOptions; let i = index">
              <button class="nav-link" [id]="element.name" [ngClass]="element.id==1 ? 'active' : ''"
                      data-bs-toggle="pill" data-bs-target="#v-pills-focus" type="button" role="tab"
                      aria-controls="v-pills-focus" aria-selected="true"
                      (click)="showContentOnHover($event)">{{ element.name }}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="watch-list" role="tabpanel" aria-labelledby="watch-list-tab"
             tabindex="0">
          <div *ngIf="fundListingData" class="funds-container" style="padding-top: 4px;">
            <ng-container *ngFor='let fund of fundListingData; let i = index'>
              <ft-home-fund-card [brConfiguration]="brConfiguration" [fund]="fund"
                                 [hasThreeDotOptions]="true"></ft-home-fund-card>

            </ng-container>
          </div>
        </div>
        <div class="tab-pane fade" id="recent-searches" role="tabpanel" aria-labelledby="recent-searches-tab"
             tabindex="0">
          <div *ngIf="recentSearchFunds" class="funds-container" style="padding-top: 4px;">
            <ng-container *ngFor='let fund of recentSearchFunds; let i = index'>
              <ft-home-fund-card [brConfiguration]="brConfiguration" [fund]="fund"
                                 [hasThreeDotOptions]="true"></ft-home-fund-card>

            </ng-container>
          </div>
          <div *ngIf="recentSearchFunds.length === 0" class="funds-container" style="padding-top: 4px;">
            <h3>{{ "products.recentSearchNoData" | translate }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isMobileView">
  <div class="offcanvas offcanvas-end custom-offcanvas" tabindex="-1" id="offcanvasExample"
       aria-labelledby="offcanvasExampleLabel" style="z-index: 999998;">
    <div class="offcanvas-body darkOffcanvasAddbody">
      <div class="d-flex justify-content-between mt-2" style="padding: 4px 31px;">
        <div class="cardAdd">{{ "products.add-fund-button-label" | translate }}</div>
        <div type="button" data-bs-dismiss="offcanvas" aria-label="Close"><img
            src="./assets/images/comparefund/Frame 1000007569.png"></div>
      </div>
      <ng-container *ngIf="getAddFund">
        <ft-empty-page
            [brConfiguration]="brConfiguration"
            [fundData]="fundData"
            [sideFilterOptions]="sideFilterOptions"
            [fundCompareIds]="fundCompareIds"
            [comaredCardImg]="false"
            [cardTypeData]="'EMPTY_WATCHLIST'"
            [addFundData]="true"
            pageSubHeading="{{ 'products.empty-page-subHeading' | translate }}">
        </ft-empty-page>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngIf="isMobileView && isMobileAddClicked && getAddFund">
  <ft-empty-page
      [fundData]="fundData"
      [sideFilterOptions]="sideFilterOptions"
      [brConfiguration]="brConfiguration"
      [fundCompareIds]="fundCompareIds"
      [comaredCardImg]="false"
      [cardTypeData]="'EMPTY_WATCHLIST'"
      [addFundData]="true"
      [isMobileAdd]="true"
      pageSubHeading="{{ 'products.empty-page-subHeading' | translate }}">
  </ft-empty-page>
</ng-container>


<!-- Dialoge: Watchlist Full button alert -->
<div class="save-alert" style="z-index:10000" *ngIf="watchListFull">
  <div class="content pt-5">
    <span class="close-btn" (click)="closeWatchListFull()">
      <img alt="Close" src="assets/images/general/close.webp">
    </span>
    <span> {{ "products.add-fund-watch-list-max-limit-message" | translate }} </span>
  </div>
</div>
